export const SET_VIEWING_COMPANY = 'setViewingCompany';
export const CLEAR_COMPANY_STATE = 'clearCompanyState';
